import { createContext } from 'react';

const SyncContext = createContext();

export default SyncContext;
